export enum DowntimeReasonModalEvent {
  Submit = 'SUBMIT',
  Dismiss = 'DISMISS',
}
